import { createAsyncThunk } from '@reduxjs/toolkit'

import { ILocationData } from 'meta/pages/v4/location'
import { LocationController } from 'controller/location'

type Returned = ILocationData[]

type Props = {
  idsOrCodeUrls: string[]
}

export const getBulkData = createAsyncThunk<Returned, Props>('pages/location/bulk', async (props) => {
  const { idsOrCodeUrls } = props

  const data = await LocationController.getBulkData({ idsOrCodeUrls })

  return data.items
})
